import { useEffect, useState } from 'react';
import { demoUsers, login, type DemoUser, type User } from './auth';

/**
 * Экран входа. Демо-режим — карточки ролей (как role-gate в демо):
 * клик по роли логинит соответствующий демо-аккаунт. Плюс ручная форма.
 */
export function LoginScreen({ onLogin }: { onLogin: (u: User) => void }) {
  const [demos, setDemos] = useState<DemoUser[]>([]);
  const [demoPass, setDemoPass] = useState('demo1234');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    demoUsers()
      .then((d) => {
        setDemos(d.users);
        setDemoPass(d.password);
      })
      .catch(() => {});
  }, []);

  async function doLogin(mail: string, pass: string) {
    setBusy(true);
    setError(null);
    try {
      onLogin(await login(mail, pass));
    } catch (e) {
      setError(
        e instanceof Error && e.message === 'invalid_credentials'
          ? 'Неверный логин или пароль'
          : 'Ошибка входа',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login-head">
        <h1>AZAM · Пульт завода</h1>
        <p className="muted">Выберите демо-роль для входа — интерфейс покажет только её экраны.</p>
      </div>

      <div className="rolegrid">
        {demos.map((d) => (
          <button
            key={d.email}
            className="rolecard"
            disabled={busy}
            onClick={() => doLogin(d.email, demoPass)}
          >
            <div className="ri">{d.ico}</div>
            <div className="rn">{d.role_name}</div>
            <div className="rd">{d.descr}</div>
          </button>
        ))}
      </div>

      <div className="login-or">
        <span>или войдите по логину и паролю</span>
      </div>

      <form
        className="manual"
        onSubmit={(e) => {
          e.preventDefault();
          doLogin(email.trim(), password);
        }}
      >
        <input
          type="email"
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
        />
        <input
          type="password"
          placeholder="пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
        <button type="submit" className="btn" disabled={busy}>
          Войти
        </button>
      </form>

      {error && <p className="err">{error}</p>}
      <p className="muted small">
        Демо-пароль для всех ролей: <code>{demoPass}</code>
      </p>
    </div>
  );
}
